/** @prettier */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { displayModal } from '@xanadu/ui-shared/modules/modal/actions';
import { setTermsFields } from '@xanadu/ui-shared/modules/termsAndConditions/actions';
import { registrationRequest } from '@xanadu/ui-shared/modules/userRegistration/actions';
import { loginRequest, loginUser } from '@xanadu/ui-shared/modules/userSession/actions';

import Login from '../../../components/login/Login';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loginUser,
      loginRequest,
      registrationRequest,
      displayModal,
      setTermsFields,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    userStatus: state.getIn(['user', 'status']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    loginErrors: state.getIn(['user', 'loginErrors']),
    showResetPassword: state.getIn(['user', 'showResetPassword']),
    loginImage: state.getIn(['application', 'loginImage']),
    loginImageZero: state.getIn(['application', 'loginImageZero']),
    loginImageCasino: state.getIn(['application', 'loginImageCasino']),
    loginImageLiveCasino: state.getIn(['application', 'loginImageLiveCasino']),
    loginImageVirtuals: state.getIn(['application', 'loginImageVirtuals']),
    product: state.getIn(['application', 'product']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
